import { apiSlice } from '../api/apiSlice'
import { EmployeeVacation, UpdateVacationType, VacationRequestProps } from '../../types/utils/VacationTypes'
import { vacationAcknowledgementApiSlice } from './vacationAcknowledgementApiSlice'

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getEmployeeVacations: builder.query<EmployeeVacation[], VacationRequestProps>({
      query: (props: VacationRequestProps) => ({
        url: `vacation`,
        method: 'GET',
        params: props,
      }),
      providesTags: () => [{ type: 'Vacation', id: 'LIST' }],
    }),
    saveEmployeeVacations: builder.mutation({
      query: ({ dto }) => ({
        url: `vacation`,
        method: 'POST',
        body: dto,
      }),
      invalidatesTags: () => [
        { type: 'Vacation', id: 'LIST' },
        { type: 'Worklog', id: 'LIST' },
        { type: 'Vacation', id: 'UPCOMING_LIST' },
        { type: 'VacationAcknowledgement' },
        { type: 'YearlySummary', id: 'LIST' },
      ],
    }),
    deleteEmployeeVacations: builder.mutation({
      query: ({ dto }) => ({
        url: `vacation`,
        method: 'DELETE',
        body: dto,
      }),
      invalidatesTags: () => [
        { type: 'Vacation', id: 'LIST' },
        { type: 'Worklog', id: 'LIST' },
        { type: 'Vacation', id: 'UPCOMING_LIST' },
        { type: 'VacationAcknowledgement' },
        { type: 'YearlySummary', id: 'LIST' },
      ],
    }),
    updateEmployeeVacations: builder.mutation<void, { dto: UpdateVacationType; requestProps: VacationRequestProps }>({
      query: ({ dto }) => ({
        url: `vacation`,
        method: 'PUT',
        body: dto,
      }),
      async onQueryStarted({ dto, requestProps }, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled
          const listResult = await dispatch(
            extendedApiSlice.endpoints.getEmployeeVacations.initiate(requestProps, { forceRefetch: true })
          ).unwrap()
          listResult.forEach(employee => {
            employee.vacation.forEach(vacation => {
              dispatch(
                vacationAcknowledgementApiSlice.endpoints.getVacationAcknowledgement.initiate(vacation.vacationId, {
                  forceRefetch: true,
                })
              )
            })
          })
        } catch {}
      },
      invalidatesTags: () => [
        { type: 'Worklog', id: 'LIST' },
        { type: 'Vacation', id: 'UPCOMING_LIST' },
        { type: 'YearlySummary', id: 'LIST' },
      ],
    }),
    checkVacationExists: builder.query<boolean, string>({
      query: (vacationId: string) => ({
        url: `vacation/${vacationId}`,
        method: 'GET',
      }),
    }),
  }),
})

export const {
  useGetEmployeeVacationsQuery,
  useSaveEmployeeVacationsMutation,
  useDeleteEmployeeVacationsMutation,
  useUpdateEmployeeVacationsMutation,
  useCheckVacationExistsQuery,
  useLazyCheckVacationExistsQuery
} = extendedApiSlice
